import script from "./TableContainer.vue?vue&type=script&lang=ts"
export * from "./TableContainer.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__